module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-result"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "encircle"
  }, [_c('h1', [_vm._v("支付状态")]), _vm._v(" "), _c('div', {
    staticClass: "deliver"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "700px"
    }
  }, [_c('div', {
    staticClass: "order-list",
    on: {
      "click": function($event) {
        return _vm.backOrder()
      }
    }
  }, [_vm._v("支付失败！返回我的订单")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-nav"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/pay.jpg",
      "alt": "购物车及购物车进程"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "93px",
      "height": "105px"
    },
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg",
      "alt": "支付失败"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc0c2b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shopping-cart/payError.vue
// module id = 1583
// module chunks = 1